import { render, staticRenderFns } from "./FilaAtendimentoChat.vue?vue&type=template&id=4e097ad3&scoped=true&"
import script from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimentoChat.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimentoChat.vue?vue&type=style&index=0&id=4e097ad3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e097ad3",
  null
  
)

export default component.exports